<template>
  <section>
    <div class="card rounded mb-5 podft-filter" v-if="showBack">
      <div class="card-header p-3 min-h-45px h-45px collapsible cursor-pointer rotate collapsed" data-bs-toggle="collapse" data-bs-target="#filter">
        <h5 class="card-title text-gray-700 fs-5 m-0 ms-3 text-gray-700 fw-bold">Поиск</h5>
        <div class="card-toolbar rotate-180 m-0 me-3">
          <i class="ki-duotone ki-down fs-3"></i>
        </div>
      </div>
      <div id="filter" class="collapse">
        <div class="card-body p-5">
          <div class="row">
            <div class="col-xl-4 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                ИИН/БИН/НД <small class="fw-bold">"Страхователь"</small>
              </div>
              <div class="input-group input-group-sm mb-5 mb-lg-0">
                <input v-model="filter.insurer" type="text" class="form-control" name="filter.insurer" id="filter.insurer" placeholder="ИИН/БИН/Номер документа"/>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                ФИО <small class="fw-bold">"Автор"</small>
              </div>
              <div class="input-group input-group-sm mb-5 mb-lg-0">
                <input v-model="filter.user" type="text" class="form-control" name="filter.user" id="filter.user" placeholder="ФИО"/>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="text-gray-600 mb-2 fs-8">
                Продукт
              </div>
              <div class="input-group input-group-sm mb-5 mb-lg-0">
                <select v-model="filter.product" class="form-select" name="filter.status" id="filter.status">
                  <option value="">Все</option>
                  <option v-for="item in productList" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-between p-3">
          <button type="button" class="btn btn-light-warning btn-sm" @click="changeFilter(true)">Сбросить</button>
          <button type="button" class="btn btn-primary btn-sm" @click="changeFilter()">Применить</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'DraftFilter',
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showBack: true,
      productList: [
        {id:1, name:'ОГПО ВТС'},
        {id:2, name:'ОГПО ВТС (ВВ)'},
        {id:3, name:'ОГПО ВТС (Т)'},
        {id:4, name:'Недв. имущество (ФИ)'},
        {id:5, name:'Движ. имущество (ФИ)'},
        {id:6, name:'Каско (ФИ)'},
      ]
    }
  },
  methods: {
    changeFilter(isClear = false) {
      if (isClear) {
        const filter = {
          insurer: '',
          product: '',
          user: '',
        }
        this.$emit('changeFilter', filter)
      } else {
        this.$emit('changeFilter', true)
      }
    },
  }
}
</script>

<style></style>